export const LEGACY_FARBEN: { code: string; name: string; hex: string }[] = [
  { code: "0", name: "black", hex: "#000000" },
  { code: "1", name: "dark_blue", hex: "#0000AA" },
  { code: "2", name: "dark_green", hex: "#00AA00" },
  { code: "3", name: "dark_aqua", hex: "#00AAAA" },
  { code: "4", name: "dark_red", hex: "#AA0000" },
  { code: "5", name: "dark_purple", hex: "#AA00AA" },
  { code: "6", name: "gold", hex: "#FFAA00" },
  { code: "7", name: "gray", hex: "#AAAAAA" },
  { code: "8", name: "dark_gray", hex: "#555555" },
  { code: "9", name: "blue", hex: "#5555FF" },
  { code: "a", name: "green", hex: "#55FF55" },
  { code: "b", name: "aqua", hex: "#55FFFF" },
  { code: "c", name: "red", hex: "#FF5555" },
  { code: "d", name: "light_purple", hex: "#FF55FF" },
  { code: "e", name: "yellow", hex: "#FFFF55" },
  { code: "f", name: "white", hex: "#FFFFFF" },
];

const f = Math.fround;

/** HSV wie Adventure (HSVLike.fromRGB), in float-Genauigkeit gerechnet, damit Gleichstände gleich ausgehen. */
function hsv(hex: string): [number, number, number] {
  const n = Number.parseInt(hex.slice(1), 16);
  const r = f(((n >> 16) & 255) / 255);
  const g = f(((n >> 8) & 255) / 255);
  const b = f((n & 255) / 255);
  const min = Math.min(r, g, b);
  const max = Math.max(r, g, b);
  const delta = f(max - min);
  const s = max !== 0 ? f(delta / max) : 0;
  if (s === 0) return [0, s, max];
  let h: number;
  if (r === max) h = f(f(g - b) / delta);
  else if (g === max) h = f(2 + f(f(b - r) / delta));
  else h = f(4 + f(f(r - g) / delta));
  h = f(h * 60);
  if (h < 0) h = f(h + 360);
  return [f(h / 360), s, max];
}

function abstand(a: [number, number, number], b: [number, number, number]): number {
  const dh = f(Math.abs(f(a[0] - b[0])));
  const farbton = f(3 * Math.min(dh, f(1 - dh)));
  const ds = f(a[1] - b[1]);
  const dv = f(a[2] - b[2]);
  return f(f(f(farbton * farbton) + f(ds * ds)) + f(dv * dv));
}

const VORAB = LEGACY_FARBEN.map((l) => ({ ...l, hsv: hsv(l.hex) }));

export function naechsteLegacyFarbe(hex: string): { code: string; hex: string } {
  const gross = hex.toUpperCase();
  const genau = LEGACY_FARBEN.find((l) => l.hex === gross);
  if (genau) return { code: genau.code, hex: genau.hex };
  const ziel = hsv(gross);
  let beste = VORAB[0]!;
  let besterAbstand = Number.POSITIVE_INFINITY;
  for (const l of VORAB) {
    const d = abstand(ziel, l.hsv);
    if (d < besterAbstand) {
      besterAbstand = d;
      beste = l;
    }
  }
  return { code: beste.code, hex: beste.hex };
}
